<template>
  <VirtualList ref="list" :items="children" #default="item">
    <Child
      class="mb-1"
      :key="item.id"
      :child="item"
      :searchQuery="searchQuery"
      :showChevron="showChevron || isChildChevronShown(item.id)"
      :showCheckbox="showCheckbox || isChildChecked(item.id)"
      :isChecked="isChildChecked(item.id)"
      :isIndeterminate="isChildIndeterminate(item.id)"
      :disableCheck="disableCheck"
      @click="$emit('click', $event)"
      @check="$emit('check', $event)"
    />
  </VirtualList>
</template>

<script setup>
import { ref } from "vue";
import Child from "@/Components/Child.vue";
import VirtualList from "@/Components/VirtualList.vue";

defineEmits(["click", "check"]);

const list = ref(null);

const props = defineProps({
  children: {
    type: Array,
    default: () => [],
  },
  showChevron: {
    type: Boolean,
    default: false,
  },
  searchQuery: {
    type: String,
    required: false,
  },
  showCheckbox: {
    type: Boolean,
    default: false,
  },
  chevronChildren: {
    type: Array,
    default: () => [],
  },
  checkedChildren: {
    type: Array,
    default: () => [],
  },
  indeterminateChildren: {
    type: Array,
    default: () => [],
  },
  disableCheck: {
    type: Boolean,
    default: false,
  },
});

function isChildChecked(childId) {
  return props.checkedChildren.includes(childId);
}

function isChildIndeterminate(childId) {
  return props.indeterminateChildren.includes(childId);
}

function isChildChevronShown(childId) {
  return props.chevronChildren.includes(childId);
}

defineExpose({
  scrollToSelection: (activeChildIds) => {
    list.value.scrollToIndex(
      props.children.findIndex((child) => activeChildIds.includes(child.id))
    );
  },
});
</script>
